<template>
  <div id="endpayment">
    <h4 class="mb-3 word-bold">繳費確認...</h4>
    <hr>
    <br>
    <br>
    <br>
    <br>
    <br>
    <br>
    <br>
    <br>
    <br>
    <br>
    <br>
    <br>
    <br>
  </div>
</template>

<script>
import { apiFeeorderShoppay } from '../../Api/api'
import $ from 'jquery'
export default {
  created () {
    this.endCheck()
  },
  methods: {
    endCheck () { // 購物車繳費 F_API 012
      // 定義資料
      const vm = this
      const Identity = JSON.parse(localStorage.getItem('M_Identity'))
      delete Identity.ApplyDeptId
      const LinepayData = JSON.parse(localStorage.getItem('Linepay'))
      const PayUserData = JSON.parse(localStorage.getItem('PayUserData'))
      if (!LinepayData) {
        vm.$bus.$emit('Modals', '錯誤的繳費流程。')
        $('#CheckError').modal('show')
        vm.$router.push({ name: 'Feeorder_Personal' })
        return false
      }
      const NewData = Object.assign(Identity, LinepayData, PayUserData)
      NewData.PrintDT = ''
      NewData.PrintBarcode1 = ''
      NewData.PrintBarcode2 = ''
      NewData.PrintBarcode3 = ''
      NewData.PrintDebtNo = ''
      // 呼叫API
      apiFeeorderShoppay(NewData).then(
        res => {
          if (res !== undefined) {
            localStorage.removeItem('PayUserData')
            localStorage.removeItem('Linepay')
            vm.$bus.$emit('Modals', '交易成功')
            $('#CheckOk').modal('show')
            setTimeout(function () { // 延遲兩秒導向申請頁面，modal訊息會吃到申請頁面訊息，所以延遲避開
              $('#CheckOk').modal('hide')
              vm.$router.push({ name: 'Feeorder_Personal' }) // 導向 證件申請頁面
            }, 2000)
          } else {
            $('#CheckError').modal('show')
            setTimeout(function () { // 延遲兩秒導向申請頁面，modal訊息會吃到申請頁面訊息，所以延遲避開
              $('#CheckOk').modal('hide')
              vm.$router.push({ name: 'Feeorder_Personal' }) // 導向 證件申請頁面
            }, 2000)
          }
        }
      )
    }
  }
}
</script>
